import {type IPeachPayCustomer} from '../../../@type/peachpay/customer';

const CHECKOUT_CUSTOMER_KEY = 'peachpay_checkout_customer';
const INPROGRESS_CUSTOMER_KEY = 'peachpay_inprogress_customer';

export function getCustomer(inprogress = false): IPeachPayCustomer | null {
	try {
		return JSON.parse(localStorage.getItem(inprogress ? INPROGRESS_CUSTOMER_KEY : CHECKOUT_CUSTOMER_KEY) ?? 'null') as IPeachPayCustomer;
	} catch {
		// If the browser blocks third party cookies, just skip the existing
		// customer feature for now since we cannot use local storage
		return null;
	}
}

export function setCustomer(customer: IPeachPayCustomer, inprogress = false): boolean {
	if (!customer) {
		return false;
	}

	try {
		localStorage.setItem(inprogress ? INPROGRESS_CUSTOMER_KEY : CHECKOUT_CUSTOMER_KEY, JSON.stringify(customer));

		return true;
	} catch {
		return false;
	}
}

export function clearCustomer(): boolean {
	try {
		localStorage.removeItem(CHECKOUT_CUSTOMER_KEY);
		localStorage.removeItem(INPROGRESS_CUSTOMER_KEY);

		return true;
	} catch {
		return false;
	}
}
